module.exports = __webpack_public_path__ + "static/media/airconditioner_wind.24ea6d0c.png";